import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Lo que pasó al pedirla: ya estaba, espera a World Office, quedó en la cola
 * o —sin IVA (0272)— quedó pasada solo en la app.
 */
export type ResultadoFev =
  | 'ya_pedida'
  | 'esperando_world_office'
  | 'en_cola'
  | 'sin_iva'
  // 0296: decidida como remisión.
  | 'remision_en_cola'
  | 'remision_en_espera'
  // 0300: tenía renglones con el IVA cambiado y se partió en dos.
  | 'partida_por_iva'

/**
 * Bodega marca una cotización aceptada como lista para FEV (fn_pasar_a_fev,
 * 0252). Queda en la cola que el worker de World Office convierte en factura;
 * si tiene un cambio en camino, entra a la cola sola cuando se confirme.
 */
export function usePasarAFev() {
  const cliente = useQueryClient()

  return useMutation({
    mutationFn: async (cotizacionId: string): Promise<ResultadoFev> => {
      const { data, error } = await supabase.rpc('fn_pasar_a_fev', {
        p_cotizacion_id: cotizacionId,
      })
      if (error) throw new Error(mensajeDeError(error))
      return data as ResultadoFev
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['alistamientos'] })
      // 0301: lo que es solo servicios se pasa desde cartera.
      await cliente.invalidateQueries({ queryKey: ['cartera'] })
    },
  })
}
